import React from "react";
import { useNavigate  } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Headings from "../../constants/headings";
import { LogOut, RefreshState } from "../../functions/index";
import headerLogo from "../../assets/images/svg/header_logo_icon.svg";
function Header(props) {
  const navigate  = useNavigate ();
  const goHome = async () => {
    navigate ("/");
    RefreshState();
  };
  return (
    <header>
      <img onClick={goHome} src={headerLogo} alt="header logo" />
      {props.login && (
        <Dropdown>
          <Dropdown.Toggle variant="success">
            {Headings.userDropDown}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                LogOut();
                RefreshState();
              }}
            >
              {Headings.logOut}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </header>
  );
}
export default Header;
